import axios from "axios";
import Links from "@/shared/constants/Links";

/** Defense event and student-roster API. */

const base = Links.defenses.base;

const Defenses = {
    /**
     * Create a dated department defense event. HOD only.
     */
    create: async (data) => {
        return axios.post(base, data);
    },

    /**
     * List events, optionally filtered by department and/or student decision.
     * HOD requests must not include department; the backend restricts them to their own.
     * @param {{department?: number|string|null, status?: string|null}} filters
     */
    all: async (filters = {}) => {
        const params = {};
        if (filters.department) params.department = filters.department;
        if (filters.status) params.status = filters.status;
        return axios.get(base, { params });
    },

    /**
     * Get an event including its student roster.
     * @param {number|string} id
     */
    get: async (id) => {
        return axios.get(`${base}/${id}`);
    },

    /**
     * Change an event date. HOD only.
     * @param {number|string} id
     * @param {object} data DefenseRequest fields
     */
    update: async (id, data) => {
        return axios.put(`${base}/${id}`, data);
    },

    /**
     * Submit an event roster to the SPGS dean. HOD only.
     * The event becomes read-only after submission.
     */
    submit: async (id) => {
        return axios.patch(`${base}/${id}/submit`);
    },

    /**
     * Add a student to an event roster. HOD only.
     */
    addStudent: async (defenseId, data) => {
        return axios.post(`${base}/${defenseId}/students`, data);
    },

    /**
     * Remove a pending roster entry. HOD only.
     */
    removeStudent: async (defenseId, defenseStudentId) => {
        return axios.delete(`${base}/${defenseId}/students/${defenseStudentId}`);
    },

    /** Approve a pending or rejected roster entry. DEAN_SPGS only. */
    approveStudent: async (defenseId, defenseStudentId) => {
        return axios.patch(`${base}/${defenseId}/students/${defenseStudentId}/approve`);
    },

    /** Reject a pending or approved roster entry. DEAN_SPGS only. */
    rejectStudent: async (defenseId, defenseStudentId, reason) => {
        return axios.patch(`${base}/${defenseId}/students/${defenseStudentId}/reject`, { reason });
    },

    /** Assign or replace the event PG representative. DEAN_SPGS only. */
    assignPgRepresentative: async (defenseId, lecturerId) => {
        return axios.put(`${base}/${defenseId}/pg-representative`, { lecturerId });
    },

    /**
     * Delete an event before HOD submission. HOD only.
     * @param {number|string} id
     */
    delete: async (id) => {
        return axios.delete(`${base}/${id}`);
    },
};

export default Defenses;
